import React, { PureComponent } from 'react';
import { Card, Grid, Typography, Box, Tabs, Tab } from '@mui/material';
import { withStyles } from '@mui/styles';
import PeopleIcon from '@mui/icons-material/People';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EventIcon from '@mui/icons-material/Event';
import dataProvider from '../../providers/dataProvider';
import SessionCompletedChart from './SessionCompletedChart';
import SessionByProgramChart from './SessionByProgramChart';
import isStaff from '../../utils/isStaff';

const styles = () => ({
  statCard: {
    padding: '28px 24px',
    borderRadius: '12px',
    background: 'linear-gradient(135deg, #FFFFFF 0%, #F8F9FA 100%)',
    border: '1px solid #F0F2F5',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
      borderColor: '#16C0E8',
    },
  },
  statNumber: {
    fontSize: '2.5rem',
    fontWeight: 700,
    color: '#21262D',
    lineHeight: 1.2,
    marginBottom: '8px',
  },
  statLabel: {
    fontSize: '0.875rem',
    color: '#6C7888',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  statIcon: {
    fontSize: '40px',
    opacity: 0.2,
    marginBottom: '12px',
  },
  chartCard: {
    padding: '32px',
    borderRadius: '12px',
  },
  tabs: {
    '& .MuiTabs-indicator': {
      backgroundColor: '#16C0E8',
      height: '3px',
      borderRadius: '3px 3px 0 0',
    },
  },
  tab: {
    textTransform: 'none',
    fontSize: '0.9375rem',
    fontWeight: 500,
    minWidth: 100,
    '&.Mui-selected': {
      color: '#16C0E8',
      fontWeight: 600,
    },
  },
});

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: '7',
      dashboard: {},
    };
  }

  componentDidMount() {
    this.getDashboardData(7);
  }

  getDashboardData = (value) => {
    dataProvider('GET_ALL', `dashboard?days=${value}`).then((res) => {
      this.setState({ dashboard: res.data });
    });
  };

  handleChange = (event, value) => {
    this.setState({ value });
    this.getDashboardData(value);
  };

  render() {
    const { classes } = this.props;
    const { value, dashboard } = this.state;
    let user = localStorage.getItem('user');
    if (!user) {
      return null;
    }
    user = JSON.parse(user);
    if (!isStaff(user)) {
      return null;
    }

    const statCards = [
      {
        value: dashboard.newUsers || 0,
        label: 'New Users',
        icon: <PeopleIcon className={classes.statIcon} />,
        color: '#16C0E8',
      },
      {
        value: dashboard.startedSessions || 0,
        label: 'Sessions Started',
        icon: <PlayCircleOutlineIcon className={classes.statIcon} />,
        color: '#0EA0C3',
      },
      {
        value: dashboard.completedSession || 0,
        label: 'Sessions Completed',
        icon: <CheckCircleOutlineIcon className={classes.statIcon} />,
        color: '#d84181',
      },
      {
        value: dashboard.scheduledSessions || 0,
        label: 'Scheduled Sessions',
        icon: <EventIcon className={classes.statIcon} />,
        color: '#6F79AE',
      },
    ];

    return (
      <Box sx={{ p: 3 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 4,
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#21262D' }}>
            Dashboard
          </Typography>
          <Tabs value={value} onChange={this.handleChange} className={classes.tabs}>
            <Tab label="7 days" value="7" className={classes.tab} />
            <Tab label="30 days" value="30" className={classes.tab} />
            <Tab label="60 days" value="60" className={classes.tab} />
          </Tabs>
        </Box>

        <Grid container spacing={3}>
          {statCards.map((stat) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={stat.label}>
              <Card className={classes.statCard}>
                <Box sx={{ textAlign: 'center' }}>
                  <Box sx={{ color: stat.color }}>{stat.icon}</Box>
                  <Typography className={classes.statNumber}>{stat.value}</Typography>
                  <Typography className={classes.statLabel}>{stat.label}</Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid size={{ xs: 12, md: 9 }}>
            <Card className={classes.chartCard}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
                Sessions Completed
              </Typography>
              {dashboard.sessionsByDay ? (
                <SessionCompletedChart data={dashboard.sessionsByDay} />
              ) : (
                <Typography sx={{ color: '#6C7888', py: 4, textAlign: 'center' }}>
                  No data available
                </Typography>
              )}
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Card className={classes.chartCard}>
              <Typography variant="h6" sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}>
                Sessions by Program
              </Typography>
              {dashboard.sessionsByProgram ? (
                <SessionByProgramChart data={dashboard.sessionsByProgram} />
              ) : (
                <Typography sx={{ color: '#6C7888', py: 4, textAlign: 'center' }}>
                  No data available
                </Typography>
              )}
            </Card>
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default withStyles(styles)(Dashboard);
